import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { classNames } from "@via/utils/helpers.tsx";

interface Step {
  name: string;
  isCompleted: boolean;
}

interface StepProgressProps {
  steps: Step[];
  currentStepIndex: number;
  onStepClick?: (stepIndex: number) => void;
}

export function StepProgress({
  steps,
  currentStepIndex,
  onStepClick,
}: StepProgressProps) {
  return (
    <nav aria-label="Progress" className="w-full">
      <ol role="list" className="flex items-center justify-center space-x-4">
        {steps.map((step, stepIdx) => (
          <li
            key={step.name}
            className={classNames(
              "flex items-center",
              onStepClick
                ? "cursor-pointer hover:opacity-80 transition-opacity"
                : ""
            )}
            onClick={() => {
              if (onStepClick) {
                onStepClick(stepIdx);
              }
            }}>
            <div className="flex items-center">
              {step.isCompleted ? (
                <CheckCircleIcon className="h-5 w-5 text-green-600" />
              ) : (
                <div
                  className={classNames(
                    "h-5 w-5 rounded-full border flex items-center justify-center text-xs",
                    stepIdx === currentStepIndex
                      ? "border-indigo-600 bg-indigo-600 text-white font-semibold"
                      : "border-gray-300 bg-gray-300"
                  )}>
                  {stepIdx + 1}
                </div>
              )}
              <span
                className={classNames(
                  "ml-2 text-sm font-medium",
                  stepIdx === currentStepIndex
                    ? "text-indigo-600"
                    : step.isCompleted
                      ? "text-gray-900"
                      : "text-gray-500"
                )}>
                {step.name}
              </span>
            </div>

            {stepIdx !== steps.length - 1 && (
              <ChevronRightIcon
                className="ml-4 h-5 w-5 text-gray-300"
                aria-hidden="true"
              />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
